module.exports = __webpack_public_path__ + "static/media/SimplonNorm-Bold.11e8b2c9.woff2";